import { drawing, geometry } from '@progress/kendo-drawing';
import { START } from '../constants.js';
import { MarkerBase } from './MarkerBase.js';
import { lineAngle } from './utils.js';
import { deepExtend } from '../utils/deep-extend.js';

const defaultOptions = {
    path: 'M 0 0 L 10 5 L 0 10 L 3 5 z',
    anchor: {
        x: 10,
        y: 5
    }
};
class ArrowMarker extends MarkerBase {
    constructor(options) {
        options = deepExtend({}, defaultOptions, options);
        super(options);
    }
    createElement() {
        const options = this.options;
        this.drawingElement = drawing.Path.parse(options.path, {
            fill: options.fill,
            stroke: options.stroke
        });
    }
    positionMarker(path) {
        const points = this._linePoints(path);
        const start = points.start;
        const end = points.end;
        const transform = geometry.transform();
        if (start) {
            transform.rotate(lineAngle(start, end), end);
        }
        if (end) {
            const anchor = this.anchor;
            const translate = end.clone().translate(-anchor.x, -anchor.y);
            transform.translate(translate.x, translate.y);
        }
        this.drawingElement.transform(transform);
    }
    _linePoints(path) {
        const options = this.options;
        const segments = path.segments;
        let startPoint, endPoint, targetSegment;
        if (options.position === START) {
            targetSegment = segments[0];
            if (targetSegment) {
                endPoint = targetSegment.anchor();
                startPoint = targetSegment.controlOut();
                const nextSegment = segments[1];
                if (!startPoint && nextSegment) {
                    startPoint = nextSegment.anchor();
                }
            }
        }
        else {
            targetSegment = segments[segments.length - 1];
            if (targetSegment) {
                endPoint = targetSegment.anchor();
                startPoint = targetSegment.controlIn();
                const prevSegment = segments[segments.length - 2];
                if (!startPoint && prevSegment) {
                    startPoint = prevSegment.anchor();
                }
            }
        }
        if (endPoint) {
            return {
                start: this._transformToPath(startPoint, path),
                end: this._transformToPath(endPoint, path)
            };
        }
    }
}

export { ArrowMarker };
